<template>
  <transition name="fade">
    <div
      v-if="show"
      class="popup-modal d-flex justify-content-center"
      @click="handleBackdropClick"
    >
      <div class="wizard-content" @click.stop>
        <button class="close-btn" @click="close" aria-label="Закрыть">&times;</button>
        <auth-wizard ref="loginRef" @hide="handleHide"/>
      </div>
    </div>
  </transition>
</template>

<script>
import AuthWizard from './AuthWizard.vue';
import { ref, onMounted, onUnmounted, defineExpose } from 'vue';
import api from '@/api/index';
import { redirectToVkApp } from '@/utils/vkRedirect';

export default {
    name: "WizardModal",
    components: {AuthWizard},
    props: {
        // Открывать ВК приложение в новом окне (true) или в текущем (false)
        vkRedirectNewWindow: {
            type: Boolean,
            default: true
        }
    },
    setup(props) {
        const show = ref(false);
        const loginRef = ref(null);

        const checkWizardParam = () => {
            console.log('[WizardModal] checkWizardParam: проверка параметра wizard в URL');
            const urlParams = new URLSearchParams(window.location.search);
            const wizardParam = urlParams.get('wizard');
            console.log('[WizardModal] checkWizardParam: wizard =', wizardParam);
            show.value = wizardParam === 'true';
            console.log('[WizardModal] checkWizardParam: show =', show.value);
        };

        const close = () => {
            console.log('[WizardModal] close: начало закрытия модального окна');
            console.log('[WizardModal] close: show было', show.value);
            show.value = false;
            console.log('[WizardModal] close: show стало', show.value);
            console.log('[WizardModal] close: модальное окно закрыто (show = false)');
        };

        const handleBackdropClick = (event) => {
            console.log('[WizardModal] handleBackdropClick: клик по backdrop');
            // Проверяем, что клик был на backdrop (не на внутренних элементах)
            const modalEl = event.currentTarget;
            if (event.target === modalEl) {
                console.log('[WizardModal] handleBackdropClick: клик был на backdrop, закрываем');
                close();
            } else {
                console.log('[WizardModal] handleBackdropClick: клик был на внутреннем элементе, не закрываем');
            }
        };

        const handleHide = async () => {
            console.log('[WizardModal] handleHide: ВИЗАРД ЗАКРЫЛСЯ (событие @hide от AuthWizard)');
            close();
            console.log('[WizardModal] handleHide: модальное окно скрыто, начинаем проверку авторизации');
            // После закрытия визарда проверяем статус авторизации
            try {
                console.log('[WizardModal] handleHide: вызов api.checkAuth()');
                const authData = await api.checkAuth();
                console.log('[WizardModal] handleHide: результат api.checkAuth()', authData);
                // Если vk_exists === true, делаем редирект в ВК приложение
                if (authData && authData.vk_exists) {
                    console.log('[WizardModal] handleHide: vk_exists = true, выполняем редирект');
                    console.log('[WizardModal] handleHide: параметры редиректа', {
                        newWindow: props.vkRedirectNewWindow,
                        vkRedirectNewWindow: props.vkRedirectNewWindow
                    });
                    redirectToVkApp({
                        newWindow: props.vkRedirectNewWindow
                    });
                } else {
                    console.log('[WizardModal] handleHide: vk_exists = false или нет данных, редирект НЕ выполняется');
                    console.log('[WizardModal] handleHide: authData.vk_exists =', authData?.vk_exists);
                }
            } catch (error) {
                console.error('[WizardModal] handleHide: ОШИБКА при проверке авторизации:', error);
            }
        };

        const showWizardModal = () => {
          console.log('[WizardModal] showWizardModal: открытие модального окна');
          show.value = true;
          console.log('[WizardModal] showWizardModal: show =', show.value);
        };

        const handleKeydown = (event) => {
            if (event.key === 'Escape' && show.value) {
                console.log('[WizardModal] handleKeydown: нажат Escape, закрытие модального окна');
                close();
            }
        };

        onMounted(() => {
            console.log('[WizardModal] onMounted: компонент смонтирован');
            checkWizardParam();
            window.addEventListener('popstate', checkWizardParam);
            document.addEventListener('keydown', handleKeydown);
            console.log('[WizardModal] onMounted: добавлены слушатели событий');
        });

        onUnmounted(() => {
            console.log('[WizardModal] onUnmounted: компонент размонтируется');
            window.removeEventListener('popstate', checkWizardParam);
            document.removeEventListener('keydown', handleKeydown);
            console.log('[WizardModal] onUnmounted: слушатели событий удалены');
        });

        // Экспортируем методы для доступа через $refs
        defineExpose({
            showWizardModal,
            close,
            show
        });

        console.log('[WizardModal] setup: инициализация завершена', {
            show: show.value,
            vkRedirectNewWindow: props.vkRedirectNewWindow
        });

        return {
            show,
            close,
            handleBackdropClick,
            handleHide,
            loginRef,
            showWizardModal
        };
    }
}
</script>

<style scoped>
.popup-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
    cursor: pointer;
}

.wizard-content {
    position: relative;
    cursor: default;
}

.close-btn {
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    font-size: 28px;
    color: #333;
    cursor: pointer;
    z-index: 10;
    line-height: 1;
    padding: 5px 10px;
}

.close-btn:hover {
    color: #E32289;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter-from, .fade-leave-to {
    opacity: 0;
}
</style>
